import { useEffect, useMemo } from 'react';

import { IProps } from './types';

/** При дизейбле всех свойств кроме одного, выбирает оставшееся свойство **/
export const useSelectSingleAvailableValue = ({ source, onChange }: IProps) => {
  const isSingleOptionAvailable = useMemo(() => source?.filter(item => !item.disabled).length === 1, [source]);

  useEffect(() => {
    if (isSingleOptionAvailable) {
      const checkedOption = source?.find(item => !item.disabled);
      if (checkedOption) {
        onChange(checkedOption.value);
      }
    }
  }, [isSingleOptionAvailable, onChange]);
};
